import { createBrowserRouter } from 'react-router-dom'
import { RootLayoutWithToaster } from '@/layouts/RootLayout'
import ShowLayout from '@/layouts/ShowLayout'
import EpisodeLayout from '@/layouts/EpisodeLayout'

// Pages
import HomePage from '@/pages/HomePage'
import LoginPage from '@/pages/login/LoginPage'
import SSOCallbackPage from '@/pages/sso/SSOCallbackPage'
import EpisodesPage from '@/pages/show/episodes/EpisodesPage'
import EpisodePage from '@/pages/show/episodes/episode/EpisodePage'
import ScriptPage from '@/pages/show/episodes/episode/segment/ScriptPage'
import StoryboardPage from '@/pages/show/episodes/episode/segment/StoryboardPage'
import RundownPage from '@/pages/show/episodes/episode/segment/RundownPage'
import InstructionsPage from '@/pages/show/InstructionsPage'
import SettingsPage from '@/pages/show/SettingsPage'
import StudioPage from '@/pages/show/StudioPage'
import AgentPage from '@/pages/show/AgentPage'
import TimelinesPage from '@/pages/show/timelines/TimelinesPage'
import TimelinePage from '@/pages/show/timelines/timeline/TimelinePage'
import AccountPage from '@/pages/show/AccountPage'
import CharactersPage from '@/pages/show/CharactersPage'
import AssetsPage from '@/pages/show/AssetsPage'

export const router = createBrowserRouter([
  {
    element: <RootLayoutWithToaster />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/sso',
        element: <SSOCallbackPage />,
      },
      {
        path: '/show',
        element: <ShowLayout />,
        children: [
          {
            path: 'episodes',
            element: <EpisodesPage />,
          },
          {
            path: 'episodes/:episodeId',
            element: <EpisodeLayout />,
            children: [
              {
                index: true,
                element: <EpisodePage />,
              },
              {
                path: ':segmentId/script',
                element: <ScriptPage />,
              },
              {
                path: ':segmentId/storyboard',
                element: <StoryboardPage />,
              },
              {
                path: ':segmentId/rundown',
                element: <RundownPage />,
              },
            ],
          },
          {
            path: 'instructions',
            element: <InstructionsPage />,
          },
          {
            path: 'settings',
            element: <SettingsPage />,
          },
          {
            path: 'studio',
            element: <StudioPage />,
          },
          {
            path: 'agent',
            element: <AgentPage />,
          },
          {
            path: 'timelines',
            element: <TimelinesPage />,
          },
          {
            path: 'timelines/:timelineId',
            element: <TimelinePage />,
          },
          {
            path: 'account',
            element: <AccountPage />,
          },
          {
            path: 'characters',
            element: <CharactersPage />,
          },
          {
            path: 'assets',
            element: <AssetsPage />,
          },
        ],
      },
    ],
  },
], { basename: import.meta.env.BASE_URL.replace(/\/$/, '') })
